/* eslint formatjs/no-literal-string-in-jsx: "error" */
import { FlexContainer, H3, Icon, TextLink } from "@carrotfertility/carotene"
import React from "react"
import { FormattedMessage } from "react-intl"

// Workaround to prevent needing to refactor our TextLink's to a semantic button
function clickOnPressEnter(onClick) {
  return (e) => {
    if (e.key === "Enter") {
      onClick(e)
    }
  }
}

export const NavFooter = ({
  isFirstPage,
  onNext,
  onBack,
  nextText,
  navDataAttributes
}: {
  isFirstPage: boolean
  onNext: (e: React.MouseEvent<HTMLElement>) => void
  onBack: (e: React.MouseEvent<HTMLElement>) => void
  nextText: string
  navDataAttributes: { slug: string; pageIndex: number; sectionTotalPages: number }
}): JSX.Element => {
  const { slug, pageIndex, sectionTotalPages } = navDataAttributes
  return (
    <FlexContainer
      paddingTopBottom={["small", "medium", "huge", "huge"]}
      paddingLeftRight={["medium", "medium", "huge", "huge"]}
      justifyContent={isFirstPage ? "flex-end" : "space-between"}
    >
      {!isFirstPage && (
        <TextLink
          onKeyDown={clickOnPressEnter(onBack)}
          tabIndex={0}
          role="button"
          variant="no-underline"
          color="black80"
          onClick={onBack}
        >
          <FlexContainer
            direction="row"
            alignItems="center"
            id="back-button"
            data-slug={slug}
            data-pageIndex={pageIndex}
            data-section-totalPages={sectionTotalPages}
          >
            <Icon color="carrotOrange" name="leftArrow" />
            <H3 style={{ paddingLeft: "8px" }}>
              <FormattedMessage defaultMessage="Back" description="navigate to the previous page of the guide" />
            </H3>
          </FlexContainer>
        </TextLink>
      )}
      <TextLink
        onKeyDown={clickOnPressEnter(onNext)}
        tabIndex={0}
        role="button"
        variant="no-underline"
        color="black80"
        onClick={onNext}
      >
        <FlexContainer
          direction="row"
          alignItems="center"
          id="next-button"
          data-slug={slug}
          data-pageIndex={pageIndex}
          data-section-totalPages={sectionTotalPages}
        >
          <H3 style={{ paddingRight: "8px" }}>{nextText}</H3>
          <Icon color="carrotOrange" name="rightArrow" />
        </FlexContainer>
      </TextLink>
    </FlexContainer>
  )
}
